import { useDispatch, useSelector } from "react-redux";

import editSchoolFieldAction from "../../actions/SchoolActions/editSchoolFieldAction";
import getSchoolEditedFieldSelector from "../../selectors/SchoolSelectors/getSchoolEditedFieldSelector";
import getSchoolFieldSelector from "../../selectors/SchoolSelectors/getSchoolFieldSelector";
import isEditingSchoolSelector from "../../selectors/SchoolSelectors/isEditingSchoolSelector";
import { useCallback } from "react";

export default function useEditingSchoolField(field: string) {
    const isEditing = useSelector((state: Store) => isEditingSchoolSelector(state));
    const savedValue = useSelector((state: Store) => getSchoolFieldSelector(state, field));
    const editedValue = useSelector((state: Store) => getSchoolEditedFieldSelector(state, field));
    const dispatch = useDispatch();
    const editSchoolField = useCallback(data => dispatch(editSchoolFieldAction(data, field)), [dispatch, field]);
    return {
        isEditing,
        savedValue,
        editedValue,
        editSchoolField
    };
}
